import Skeleton from "../../skeleton";

const BestTeamsLoading = () => {
  return (
    <div className="relative flex h-48 w-72 flex-col items-center justify-end gap-2 rounded-3xl bg-white p-6 pt-12 shrink-0">
      <Skeleton className="absolute -top-12 aspect-4/3 h-24 w-24 rounded-full border-4 border-solid border-white" />

      <Skeleton className="h-4 w-40 rounded" />
      <Skeleton className="h-3 w-full rounded" />
      <Skeleton className="h-16 w-40 rounded-xl" />
    </div>
  );
};

export default BestTeamsLoading;
